/**
 * @param {Array} a
 * @param {Array} b
 * @return {Array}
 */
export default function diff(a, b) {
  const diff = new Set();

  // empty states
  if (!a && !b) return [];
  if (!a?.size && b?.size) return b;
  if (!b?.size && a?.size) return a;

  // check if items in A exist in B
  a.forEach((i) => {
    if (!b.includes(i)) {
      diff.add(i);
    }
  });

  // check if items in B exist in A
  b.forEach((i) => {
    if (!a.includes(i)) {
      diff.add(i);
    }
  });

  return Array.from(diff);
}
